import * as React from "react";
import * as QRCode from 'qrcode.react';
 
export interface QRCodeProps {
    lidnummer : string;
}
export const QRCodeLidnummer = (props: QRCodeProps) => {

    return <>   
        <span className="digitaleledenpas__qrcode">
            <QRCode 
                value={props.lidnummer}
                level="H"
                size={192}                
            ></QRCode>
        </span>
    </>;
}
;